import { render } from "./ProcenaEdukacije.vue?vue&type=template&id=2f47af53&scoped=true&lang=html"
import script from "./ProcenaEdukacije.vue?vue&type=script&lang=js"
export * from "./ProcenaEdukacije.vue?vue&type=script&lang=js"

import "./ProcenaEdukacije.vue?vue&type=style&index=0&id=2f47af53&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-2f47af53"

export default script